import TextField from '../form/TextField'
import SelectField from '../form/SelectField'
import ImageField from '../form/ImageField'
import FileField from '../form/FileField'
import DateField, {formatDate} from '../form/DateField'
import TextareaField from '../form/TextareaField'
import RadioField from '../form/RadioField'
import CheckboxField from '../form/CheckboxField'
import MultiCheckboxField from '../form/MultiCheckboxField'
import TypeheadField from "./TypeheadField";
import BirthDateField from "./BirthDateField";
import {resolveApiResult} from "../../utils";

export {TextField}
export {SelectField}
export {ImageField}
export {FileField}
export {DateField, formatDate}
export {TextareaField}
export {RadioField}
export {CheckboxField}
export {MultiCheckboxField}
export {TypeheadField}
export {BirthDateField}

export const scrollToErrors = (errors) => {
	if (errors) {
		let el;
		for (let k in errors) {
			if (errors.hasOwnProperty(k)) {
				el = document.getElementById(k);
				if (el) {
					el.scrollIntoView();
					break
				}
			}
		}
	}
};

export const handleTypeheadSearch = (filter, createOption, doSearch, callback, currentValue = null) => {
	let options = [];
	if (!filter.search) {
		if (currentValue) {
			options = [createOption(currentValue)];
		}
		callback(null, {options});
		return
	}
	doSearch(filter).then((json) => {
		if (resolveApiResult(json)) {
			if (json.response.data && json.response.data.length) {
				for (let i = 0; i < json.response.data.length; i++) {
					options.push(createOption(json.response.data[i]));
				}
			}
			callback(null, {options, complete: true})
		} else {
			callback(json.response ? json.response.result : {}, null)
		}
	});
};

export function withStopPropagation(callback) {
	return function (event) {
		event.stopPropagation();
		return callback(event);
	};
}



// WEBPACK FOOTER //
// ./src/components/form/form.js